export function toArray(stringOrArray: string[] | string | undefined): string[] {
	if (stringOrArray && stringOrArray.length > 0) {
		return Array.isArray(stringOrArray) ? stringOrArray : [stringOrArray];
	} else {
		return [] as string[];
	}
}

export function toKebabCase(stringToFormat: string | undefined): string {
	if (!stringToFormat) {
		return '';
	}

	return stringToFormat
		.trim()
		.replace(/[^\w\s-]/gu, '')
		.split(/[\s-]+/)
		.join('-')
		.toLowerCase();
}

export function toCamelCase(stringToFormat: string | undefined) {
	if (!stringToFormat) {
		return '';
	}

	return stringToFormat
		.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
			return index == 0 ? word.toLowerCase() : word.toUpperCase();
		})
		.replace(/\s+/g, '');
}

export function getQueryStringParams(query: string | null | undefined) {
	if (!query || !query.includes('?')) {
		return {};
	}

	return query
		.split('?')[1]
		.split('&')
		.reduce((params: { [key: string]: string }, param) => {
			const [key, value] = param.split('=');
			params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
			return params;
		}, {});
}
